import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const CONTACT_API_BASE = process.env.REACT_APP_CONTACT_API_BASE_URL || process.env.REACT_APP__API_BASE_URL || 'https://contact.api.riolabz.com/';
const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || '';

const ContactPageContents = () => {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!showMessage) return;
    const t = setTimeout(() => setShowMessage(false), 5000);
    return () => clearTimeout(t);
  }, [showMessage]);

  const [contactData, setContactData] = useState({
    name: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    message: '',
  });
  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactData({
      ...contactData,
      [name]: value,
    });
  };
  const handlePhoneChange = (value) => {
    setContactData({
      ...contactData,
      phoneNumber: value || '',
    });
  };
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowMessage(false);

    const url = `${CONTACT_API_BASE.replace(/\/$/, '')}/api/contact-us/public/create`;
    const payload = {};
    if (COMPANY_NAME.trim()) payload.company = COMPANY_NAME.trim();
    if (contactData.name.trim()) payload.name = contactData.name.trim();
    if (contactData.lastName.trim()) payload.lastName = contactData.lastName.trim();
    if (contactData.email.trim()) payload.email = contactData.email.trim();
    if (contactData.phoneNumber.trim()) payload.phoneNumber = contactData.phoneNumber.trim();
    if (contactData.message.trim()) payload.message = contactData.message.trim();

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || 'Network response was not ok');
      }

      setMessage(data?.message || 'Contact request submitted successfully');
      setIsSuccess(true);
      setContactData({
        name: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        message: '',
      });
      setShowMessage(true);
    } catch (error) {
      setMessage(error?.message || 'Invalid contact details');
      setIsSuccess(false);
      setShowMessage(true);
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {/* Success/error toast – same as AC services (top right) */}
    {showMessage && (
      <div
        className={`hero-success-toast ${!isSuccess ? 'hero-success-toast--error' : ''}`}
        role="alert"
        aria-live="polite"
      >
        <i className={`fas ${isSuccess ? 'fa-check-circle' : 'fa-exclamation-circle'} hero-success-toast-icon`} />
        <span className="hero-success-toast-message">{message}</span>
        <button
          type="button"
          className="hero-success-toast-close"
          onClick={() => setShowMessage(false)}
          aria-label="Close"
        >
          <i className="fas fa-times" />
        </button>
      </div>
    )}
    <div className="contact-us-wrapper section-padding">
      <div className="container">
        <div className="row eq-height">
          <div className="col-lg-8 col-12">
            <div className="contact-form contact-form-left">
              <h2>Get in Touch</h2>

              <form
                // action="mail.php"
                onSubmit={handleContactSubmit}
                method="POST"
                className="row"
                id="contact-form"
              >
                <div className="col-md-6 col-12">
                  <div className="single-personal-info">
                    <input type="text" name="name" value={contactData.name} placeholder="First Name" onChange={handleContactChange} required />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="single-personal-info">
                    <input type="text" name="lastName" value={contactData.lastName} placeholder="Last Name" onChange={handleContactChange} required />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="single-personal-info">
                    <input type="email" name="email" value={contactData.email} placeholder="Email" onChange={handleContactChange} required />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="single-personal-info contact-phone-input">
                    <PhoneInput
                      international
                      defaultCountry="AE"
                      value={contactData.phoneNumber}
                      onChange={handlePhoneChange}
                      placeholder="Number"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 col-12">
                  <div className="single-personal-info">
                    <textarea
                      name="message" value={contactData.message}
                      placeholder="Message" onChange={handleContactChange}
                      required   defaultValue={""}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-12">
                  {/* <input
                    className="submit-btn"
                    type="submit"
                    disabled={isLoading}
                    defaultValue="Submit Now"
                  /> */}
                  <button
                      className="submit-btn"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <img
                          src="/img/loading-gif.gif"
                          alt="Loading..."
                          className="loading-gif"
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                </div>
              </form>
              <span className="form-message" />
            </div>
          </div>
          <div className="col-lg-4 col-12">
            <div className="contact-us-sidebar mt-5 mt-lg-0">
              <div className="contact-info">
                <h2>CONTACT INFO</h2>
                <a className="mail-text" href="mailto:INFO@dhtech.ae">
                  <div className="single-info">
                    <div className="icon">
                      <i className="flaticon-email" />
                    </div>
                    <div className="text">
                      <span className="span-contact">Email Us</span>
                      <h6 style={{ marginBottom: 0, textTransform: 'lowercase' }}>info@dhtech.ae</h6>
                    </div>
                  </div>
                </a>
                <a href="tel:+971502033924">
                <div className="single-info">
                  <div className="icon">
                    <i className="flaticon-phone-call-1" />
                  </div>
                  <div className="text">
                    <span className="span-contact">Call Us</span>
                    <h6 style={{ marginBottom: 0 }}>+971502033924</h6>
                  </div>
                </div>
                </a>
                <a href="tel:+971 4 380 9356">
                <div className="single-info">
                  <div className="icon">
                    <i className="flaticon-phone-call-1" />
                  </div>
                  <div className="text">
                    <span className="span-contact">Fax</span>
                    <h6 style={{ marginBottom: 0 }}>+971 4 380 9356</h6>
                  </div>
                </div>
                </a>
                <div className="single-info">
                  <div className="icon">
                    <i className="flaticon-phone-call-1" />
                  </div>
                  <div className="text">
                    <span>Hours</span>
                    <h6 style={{ marginBottom: 0 }}>7:30am - 5:00pm</h6>
                  </div>
                </div>
                <div className="single-info">
                  <div className="icon">
                    <i className="flaticon-pin" />
                  </div>
                  <div className="text">
                    <span>Location</span>
                    <h6 style={{ marginBottom: 0 }}>Business Center,</h6>
                    <h6 style={{ marginBottom: 0 }}>Rubaya Building,Al Qusais</h6>
                    <h6 style={{ marginBottom: 0 }}>Dubai, United Arab Emirates</h6>
                  </div>
                </div>
              </div>
              {/* <div className="live-chat">
                            <h2>Live Chat</h2>
                            <p>You can contact us on chat and explain 
                            your problems</p>
                            <Link to="/about"><i className="flaticon-chatting" /> Live Chat to Executive</Link>
                        </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ContactPageContents;
